import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-cliente-vendedor",
  templateUrl: "./cliente-vendedor.component.html",
  styleUrls: ["./cliente-vendedor.component.scss"],
})
export class ClienteVendedorComponent implements OnInit {
  constructor() {}

  optionsSucursal: Array<any> = [];
  optionsTerritorio: Array<any> = [];
  optionsCiudad: Array<any> = [];
  optionsComuna: Array<any> = [];

  ngOnInit() {
    this.optionsTerritorio = [
      { value: "1", label: "Territorio 1" },
      { value: "2", label: "Territorio 2" },
      { value: "3", label: "Territorio 3" },
    ];
    this.optionsCiudad = [
      { value: "1", label: "Ciudad 1" },
      { value: "2", label: "Ciudad 2" },
      { value: "3", label: "Ciudad 3" },
    ];
    this.optionsComuna = [
      { value: "1", label: "Comuna 1" },
      { value: "2", label: "Comuna 2" },
      { value: "3", label: "Comuna 3" },
    ];
    this.optionsSucursal = [
      { value: "1", label: "Sucursal 1" },
      { value: "2", label: "Sucursal 2" },
      { value: "3", label: "Sucursal 3" },
    ];
  }
}
